// Item store bound to the finance table (`jexis-finance-data`).
//
// Same API as model/db.js (doc-first: addItem / getItem / listItems /
// updateItem / deleteItem / removeItemAttrs), but every call targets the
// finance table. That table is PER-USER ONLY — its IAM grant fences
// `dynamodb:LeadingKeys` to the caller's own identity, with no `shared`
// partition and no indexes — so always pass the caller's userId.
//
// Money attributes in this table are INTEGER minor units (cents for AUD/USD);
// see model/finance/money.js.

import { tableStore } from '../db.js';
import { config } from '../../core/config.js';

export const financeStore = tableStore(config.financeTable);
